import { FormFieldValidation } from "store/formTemplate/formTemplateTypes";

export type FormTemplateItem =
  | OpenDivItem
  | CloseDivItem
  | HtmlItem
  | TextFieldItem
  | ComponentItem
  | AnimalProfileItem
  | AnimalCardsProfileItem
  | DynamicTenantFormItem
  | SignatureOfTenantsItem
  | InfoSectionItem;

export interface OpenDivItem {
  type: "open-div";
  className: string;
  key?: string;
}

export interface CloseDivItem {
  type: "close-div";
  className?: string;
}

export interface HtmlItem {
  type: "html";
  label: string;
  className?: string;
  key?: string;
}

export interface TextFieldItem {
  type: "text";
  name: string;
  key: string;
  label: string;
  value: string;
  access: boolean;
  fieldId: string;
  subtype: string;
  required: boolean;
  sequence: string;
  validate: boolean;
  className: string;
  maxlength: number;
  labelClass: string;
  placeholder: string;
  validations: any[];
  validationType: string;
}

export interface ComponentItem {
  type: "component";
  component: string;
  label?: string;
  validations?: FormFieldValidation[];
  [key: string]: any;
}

export interface AnimalProfileItem {
  type: "animal-profile";
  fieldsList: FormTemplateItem[];
}

export interface AnimalCardsProfileItem {
  type: "animal-cards-profile";
  animal_type: string;
  fieldsList: FormTemplateItem[];
}

export interface DynamicTenantFormItem {
  type: "dynamic_tenant_form";
  fieldsList: FormTemplateItem[];
}

export interface SignatureOfTenantsItem {
  type: "signature_of_tenants";
  fieldsList: FormTemplateItem[];
}

export interface InfoSectionItem {
  type: "info-section";
  fieldsList: FormTemplateItem[];
}

// Type guard for items with fieldsList
export function hasFieldsList(item: FormTemplateItem): item is
  | AnimalProfileItem
  | AnimalCardsProfileItem
  | DynamicTenantFormItem
  | SignatureOfTenantsItem
  | InfoSectionItem {
  return (
    "fieldsList" in item &&
    Array.isArray((item as any).fieldsList)
  );
}